import React, { useState, useEffect } from 'react';


import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import DocCard from '../../../../documentos/listarDocumentos/documentosReuniao';
import DocumentIcons from '../../../../../images/icons/document-icon.svg';
import UseStyles from '../../../useStyles';
import { useFileDrop } from '../../../../shared/uploadFile/dragDrop';

import { cadastrarDocumento, removerDocumento, getDocumentos } from '../../../../../services/reuniao/ReuniaoService';

const ReuniaoAbaDocumentos = (props) => {
  const {
    validar,
    handleStepper,
    dados,
    updateDados,
    history,
    isEditar
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [state, setState] = useState(false);

  const [arquivos, setArquivos] = useState([]);

  const atualizarAquivos = (item, key) => {
    return (
      <>
        {key !== 0 && (
          <Grid
            style={{
              margin: 0, padding: '0 10px', height: 0, position: 'relative', top: -6,
            }}
            item
            xs={12}
          >
            <hr style={{ border: '0.4px solid #dfdfe6' }} />
          </Grid>
        )}
        <DocCard key={key} file={item} onDelete={() => removeFile(key)} />
      </>
    )
  }



  const removeFile = async (chave) => {
    const idDocumento = dados.arquivos[chave].id;
    if (idDocumento) {
      const idReuniao = dados.id;
      try {
        await removerDocumento(idReuniao, idDocumento);
        const aux = dados.arquivos;
        aux.splice(chave, 1);
        updateDados({ ...dados, arquivos: aux });
        setState((prev) => !prev);
      } catch (e) {
        enqueueSnackbar('Ocorreu um erro ao remover o documento', { variant: 'error' });
      }
    }
  }

  const validarCampos = (skip = false) => {
    for (const file of dados.arquivos) {
      if (!file.nome || !file.tipo) {
        enqueueSnackbar('Informe todos os campos do(s) documento(s) para prosseguir', { variant: 'error' });
        return;
      }
    }
    validar.validado = true;

    let sucesso = true;

    dados.arquivos.forEach(async (arq) => {
      if (!arq.id) {
        const formData = new FormData();
        formData.append('idReuniao', dados.id);
        formData.append('file', arq.arquivo);
        formData.append('nome', arq.nome);
        formData.append('tipo', arq.tipo);

        try {
          const response = await cadastrarDocumento(formData);
          console.log(`Response ${response}`);
          arq.id = response.data;
        } catch (e) {
          sucesso = false;
        }
      }
    });

    if (sucesso) {
      setState((prev) => !prev);
      if (!skip) {
        handleStepper(3);
      }else {
        history.push(`/reuniao/${dados.id}/visualizar`);
      }
    }
  }

  const uploadFile = (props) => {
    const aux = dados.arquivos;
    const estruturaArquivo = {
      arquivo: props,
      nome: '',
      tipo: '',
    }
    aux.push(estruturaArquivo);
    updateDados({ ...dados, arquivos: aux });
    setState((prev) => !prev);
  }

  const onChangeHandler = (event) => {
    if (event.target.files.length > 0) {
      const arrayAuxiliar = dados.arquivos;
      const estruturaArquivo = {
        arquivo: event.target.files[0],
        nome: '',
        tipo: '',
      }
      arrayAuxiliar.push(estruturaArquivo);
      updateDados({ ...dados, arquivos: arrayAuxiliar });
      setState((prev) => !prev);
    }
  }

  const {
    DropBox, HiddenInput, onClick, drag,
  } = useFileDrop(uploadFile);

  useEffect(() => {
    setArquivos(dados.arquivos.map((item, key) => atualizarAquivos(item, key)));
  }, [state])

  useEffect(() => {
    validar.validado = true;
  }, []);

  useEffect(() => {
    if (dados && dados.id) {
      getDocumentos(dados.id).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          data.forEach((file) => {
            file.arquivo = {
              name: `${file.nome}.pdf`,
              size: file.tamanho,
              lastModified: new Date().getTime(),
              tipo: file.descricaoTipo,
            }
            file.tipo = file.descricaoTipo;
          });
          console.log('DOCS - !');
          console.log(data);
          updateDados({ ...dados, arquivos: data });
          setState((prev) => !prev);
        }
      });
    }
  }, [])

  const classes = UseStyles();

  return (
    <>
      <div style={{ marginTop: 150 }}>
        <div style={{
          padding: '0 24px', marginBottom: 24, display: 'flex', justifyContent: 'space-between',
        }}
        >
          <Typography className={classes.tituloAba}>Documentos</Typography>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            {isEditar && <Button onClick={() => validarCampos(true)} variant='contained'>Finalizar</Button>}
            <Button onClick={() => validarCampos()} variant='contained'>Próximo</Button>
          </div>
        </div>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 24,
        }}
        >
          <div style={{ width: '100%' }}>
            <HiddenInput />
            <DropBox className={drag ? classes.campoOnDragAtivo : classes.campoOnDrag}>
              <img src={DocumentIcons} />
              <div style={{ marginTop: 30 }} id="formulario">
                <label className={classes.mainButon} htmlFor="input-termo-posse" role="button">
                  Adicionar
                  arquivo
                </label>
                <input
                  style={{ display: 'none' }}
                  id="input-termo-posse"
                  type="file"
                  name="file"
                  onChange={onChangeHandler}
                />
              </div>
              <p>ou arraste os arquivos aqui para adiciona-los</p>
            </DropBox>
          </div>
        </div>
        {arquivos.length > 0
          && (
            <div style={{ padding: 20 }}>
              <div style={{ padding: 10 }}>
                <Grid container spacing={4}>
                  <Grid item md={3}>
                    <Typography className={classes.gridLabelDocumentos}>Nome</Typography>
                  </Grid>
                  <Grid item md={3}>
                    <Typography className={classes.gridLabelDocumentos}>Nome do documento</Typography>
                  </Grid>
                  <Grid item md={3}>
                    <Typography className={classes.gridLabelDocumentos}>Tipo</Typography>
                  </Grid>
                  <Grid item md={3}>
                    <Typography className={classes.gridLabelDocumentos}>Tamanho</Typography>
                  </Grid>
                </Grid>
              </div>
              <div style={{
                backgroundColor: '#fff', borderRadius: 6, border: 'solid 1px #dfdfe6', padding: 10,
              }}
              >
                <Grid container spacing={4}>
                  {arquivos}
                </Grid>
              </div>
            </div>
          )}
        <div style={{ padding: 24, display: 'flex', width: '100%', justifyContent: 'flex-end', gap: 8 }}>
          {isEditar && <Button onClick={() => validarCampos(true)} variant='contained'>Finalizar</Button>}
          <Button onClick={() => validarCampos()} variant="contained">Próximo</Button>
        </div>
      </div>

    </>
  );
}

export default ReuniaoAbaDocumentos;
